import React from 'react';
import PropTypes from 'prop-types';
import useHover from 'react-use-hover';
import styled from '@emotion/styled';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import colours from '~/utils/colours';
import ListGroup from '~/App/Components/ListGroup';
import SnapButton, {
  snapButtonTheme,
} from '~/App/Components/Buttons/SnapButton';
import { useRelativeDate } from '~/react-hooks/use-date';
import { Media } from '~/types/api';

const deleteButtonTheme = {
  ...snapButtonTheme,
  default: {
    ...snapButtonTheme.default,
    highlight: colours.red,
  },
};

const ListGroupItem = styled(ListGroup.Item)`
  justify-content: space-between;
`;

const ItemLeft = styled.div`
  display: flex;
  width: 80%;
`;

ItemLeft.Text = styled.div`
  margin-left: 10px;
  width: 85%;
`;

ItemLeft.Heading = styled.h4`
  margin-top: 5px;
  margin-bottom: 5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

const ItemRight = styled.div``;

const Image = ({ src, ...props }) =>
  React.createElement(
    styled.div(() => ({
      width: '50px',
      height: '50px',
      background: `url(${src})`,
      backgroundPosition: 'center',
      backgroundSize: 'contain',
      backgroundRepeat: 'no-repeat',
    })),
    props
  );

Image.propTypes = {
  src: PropTypes.string.isRequired,
};

ItemLeft.Image = Image;

export interface SimpleMediaItemProps {
  media: Media;
  onClick: () => void;
  active: boolean;
  onDeleteClick: () => void;
}

export default function SimpleMediaItem({
  media,
  onClick,
  active,
  onDeleteClick,
}: SimpleMediaItemProps) {
  const [hovered, hoverProps] = useHover({ mouseEnterDelayMS: 0 });
  const relativeDate = useRelativeDate(media.created_at);

  return (
    <ListGroupItem
      key={media.id}
      active={active}
      onClick={onClick}
      {...hoverProps}
    >
      <ItemLeft>
        <ItemLeft.Image src={media.url} />
        <ItemLeft.Text>
          <ItemLeft.Heading>{media.name}</ItemLeft.Heading>
          Added {relativeDate}
        </ItemLeft.Text>
      </ItemLeft>
      <ItemRight
        onClick={(evt) => evt.stopPropagation()}
        style={{ visibility: hovered ? 'visible' : 'hidden' }}
      >
        <SnapButton
          onClick={onDeleteClick}
          iconBefore={faTrashAlt}
          theme={deleteButtonTheme}
        >
          Delete
        </SnapButton>
      </ItemRight>
    </ListGroupItem>
  );
}

SimpleMediaItem.propTypes = {
  media: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
};
